import React, { Component } from 'react'
// import jwtDecode from 'jwt-decode'
import { Card, Input, Button, message } from 'antd'
import { compose, gql, graphql } from 'react-apollo'
import './style.css'

class ResetPassword extends Component {
  state = {
    email: '',
    password: ''
  }

  componentDidMount = () => {
    const { resetToken } = this.props.match.params
    this.props.checkToken({ variables: { resetToken } }).then(res => {
      // console.log(res.data)
      if (!res.data.findUserByResetToken) {
        this.props.history.push('/')
      } else {
        this.setState({ email: res.data.findUserByResetToken.email })
      }
    })
  }

  handleChangePassword = e => {
    this.setState({
      password: e.target.value
    })
  }

  handleSubmit = () => {
    const { email, password } = this.state
    this.props.resetPassword({ variables: { email, password } }).then(res => {
      message.success('Changed your password done')
      setTimeout(() => {
        this.props.history.push('/')
      }, 2000)
    })
  }

  render () {
    // const { resetToken } = this.props.match.params
    return (
      <div
        style={{ background: '#ECECEC', height: '100vh' }}
        className="resetPasswordBox"
      >
        <Card
          title="Reset Password"
          bordered={false}
          style={{ width: 300, height: 400, marginTop: 35 }}
        >
          <p>{this.state.email}</p>
          <Input
            type="password"
            placeholder="New Password"
            onChange={this.handleChangePassword}
          />
          <div className="resetPasswordBtn">
            <Button type="primary" onClick={this.handleSubmit}>Submit</Button>
          </div>

        </Card>
      </div>
    )
  }
}

const checkToken = gql`
    mutation findUserByResetToken($resetToken: String!){
        findUserByResetToken(resetToken: $resetToken) {
            email
        }
    }
`
const resetPassword = gql`
    mutation resetPassword($email: String!, $password: String!){
        resetPassword(email: $email, password: $password){
            email
        }
    }
`

export default compose(
  graphql(checkToken, {
    name: 'checkToken'
  }),
  graphql(resetPassword, {
    name: 'resetPassword'
  })
)(ResetPassword)



// WEBPACK FOOTER //
// ./src/App/ResetPassword/ResetPassword.js